module.exports = __webpack_public_path__ + "static/media/border-none.690f515f.svg";